import SettingsCard from "./components/SettingsCard";
import { CARDS } from "./data/cards";

export default function Settings() {
  return (
    <div className="h-full p-2 overflow-x-hidden overflow-y-auto rounded-lg md:p-5 animate-fadeIn bg-secondary-main custom-scrollbar">
      <div className="flex flex-col gap-5">
        {/* heading */}
        <div className="flex flex-col pb-1.5 items-start justify-between border-b md:items-center md:flex-row border-b-border">
          <label className="text-lg font-semibold leading-6 text-text-header">
            Settings
          </label>
        </div>

        {/* cards */}
        <div className="flex flex-col gap-2">
          {CARDS.map((card, index) => {
            return <SettingsCard data={card} key={index} />;
          })}
        </div>
      </div>
    </div>
  );
}
